import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { color, Common, Statics } from '@stockbit/ui';
import Image from 'global/Image';
import {
  Footer,
  Wrapper,
  HeaderContainer,
  HeaderFlex,
  MainContainer,
} from './styled';

const { Button, Flex, Text } = Common;
const { Box } = Statics;

const GuestLayout = ({
  children,
  noBox = false,
  noAuth = false,
  isCompanyStock = false,
  className = '',
}) => {
  const router = useRouter();
  const date = new Date();
  const year = date.getFullYear();

  const isGuestCompanyStock = isCompanyStock;

  return (
    <Wrapper className={className}>
      <HeaderContainer isGuestCompanyStock={isGuestCompanyStock}>
        <HeaderFlex
          align="center"
          direction="row"
          justify="space-between"
          mx="auto"
          isGuestCompanyStock={isGuestCompanyStock}
        >
          <Link href="/">
            <a>
              <Image src="/images/stockbit.svg" alt="stockbit logo" />
            </a>
          </Link>
          {!noAuth && (
            <Flex direction="row" justify="center" align="center">
              <Link href="/login">
                <a>
                  <Button
                    mr="16px"
                    className="button-login"
                    mt={isGuestCompanyStock ? 0 : '8px'}
                    type={isGuestCompanyStock ? 'default' : 'borderless'}
                  >
                    <Text
                      family={isGuestCompanyStock ? 'regular' : 'bold'}
                      color={
                        isGuestCompanyStock ? color.highempahis : color.pinkSwan
                      }
                    >
                      Login
                    </Text>
                  </Button>
                </a>
              </Link>
              <Link href="/register">
                <a>
                  <Button
                    type="primary"
                    className="button-register"
                    mt={isGuestCompanyStock ? 0 : '8px'}
                    onClick={(e) => {
                      e.preventDefault();
                      router.push('/register');
                    }}
                  >
                    <Text
                      family={isGuestCompanyStock ? 'regular' : 'bold'}
                      color={color.light}
                    >
                      Register
                    </Text>
                  </Button>
                </a>
              </Link>
            </Flex>
          )}
        </HeaderFlex>
      </HeaderContainer>
      <MainContainer
        mx="auto"
        mb="24px"
        isGuestCompanyStock={isGuestCompanyStock}
      >
        {noBox ? children : <Box style={{ width: '100%' }}>{children}</Box>}
      </MainContainer>
      <Flex>
        <Footer>
          2013-{year} Stockbit ·
          <Link href="/about">
            <a>About</a>
          </Link>
          ·
          <Link href="/contact">
            <a>Contact</a>
          </Link>
          <a href="https://help.stockbit.com/id">Help</a>·
          <Link href="/rules">
            <a>House Rules</a>
          </Link>
          ·
          <Link href="/terms">
            <a>Terms</a>
          </Link>
          ·
          <Link href="/privacy">
            <a>Privacy</a>
          </Link>
        </Footer>
      </Flex>
    </Wrapper>
  );
};

GuestLayout.propTypes = {
  children: PropTypes.node.isRequired,
  noBox: PropTypes.bool,
  noAuth: PropTypes.bool,
};

GuestLayout.defaultProps = {
  noBox: false,
  noAuth: false,
};

export default GuestLayout;
